<template>
	<div class="no-bind-wrap">
		<div class="no-bind-body" v-if="!isShowTips">
			<div class="refresh-btn" @click="refreshClick">
				<svg
					t="1642747615537"
					class="icon"
					viewBox="0 0 1024 1024"
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					p-id="3027"
					width="16"
					height="16"
				>
					<path
						d="M938.336973 255.26894c-16.685369-6.020494-35.090879 2.752226-40.939358 19.437594l-24.770032 69.493701c-29.070385-65.537376-74.998152-123.162103-133.48295-166.337645-185.947253-137.611288-450.848984-100.112212-590.180413 83.942886C81.534688 350.908785 52.980346 460.653788 68.805644 570.742819c15.825298 110.605073 74.48211 208.481102 164.789518 275.394591 75.686209 55.904586 164.273476 83.082815 252.172686 83.082815 128.494541 0 255.26894-57.624727 338.007727-166.853687 36.639006-48.335965 61.581052-102.348396 74.48211-160.833193 3.78431-17.373425-7.224593-34.402822-24.426004-38.187133-17.201411-3.78431-34.402822 7.052579-38.187133 24.426004-10.836889 49.36805-31.994625 95.123803-62.957164 135.891147-118.173694 156.016798-342.996136 187.839409-500.90509 70.869814-76.546279-56.592642-126.086343-139.33143-139.503444-232.907106-13.417101-93.059634 10.664875-185.775239 67.77356-261.11742C318.05409 144.491853 542.704519 112.497228 700.785486 229.466823c57.280699 42.315471 100.112212 100.972283 123.334117 167.197715l-110.261045-43.003528c-16.513355-6.364522-35.090879 1.720141-41.627415 18.233496-6.536536 16.513355 1.720141 35.090879 18.233496 41.627415l162.38132 63.473207c3.78431 1.548127 7.740635 2.236183 11.69696 2.236183 0.516042 0 1.032085-0.172014 1.548127-0.172014 1.204099 0.172014 2.408198 0.688056 3.612296 0.688056 13.245087 0 25.630102-8.256677 30.274483-21.32975l57.796741-161.693264C963.623047 279.694944 955.022342 261.289434 938.336973 255.26894z"
						p-id="3028"
						fill="#8a8a8a"
					></path>
				</svg>
				<span>刷新</span>
			</div>
			<div class="no-bind-title">未绑定NAS设备</div>
			<div class="no-bind-tips">首次绑定，请到本地套件中心打开</div>
			<div class="no-bind-app-name">节点小宝2.0</div>
			<div class="no-bind-app-icon"></div>
			<div class="no-bind-help" @click="showTips">
				<span>操作指南</span
				><svg
					width="16"
					height="16"
					viewBox="0 0 16 16"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g id="Frame">
						<path
							id="Vector"
							d="M7.25 12.2559C7.25 12.6701 7.58578 13.0059 8 13.0059C8.41422 13.0059 8.75 12.6701 8.75 12.2559C8.75 11.8416 8.41422 11.5059 8 11.5059C7.58578 11.5059 7.25 11.8416 7.25 12.2559Z"
							fill="#2E54A6"
						/>
						<path
							id="Vector_2"
							d="M8 15C4.14 15 1 11.86 1 8C1 4.14 4.14 1 8 1C11.86 1 15 4.14 15 8C15 11.86 11.86 15 8 15ZM8 2.00448C4.694 2.00448 2.00448 4.694 2.00448 8C2.00448 11.3055 4.694 13.9955 8 13.9955C11.3055 13.9955 13.9955 11.3055 13.9955 8C13.9955 4.694 11.3055 2.00448 8 2.00448V2.00448Z"
							fill="#2E54A6"
						/>
						<path
							id="Vector_3"
							d="M8 10.5265C7.72398 10.5265 7.5 10.3025 7.5 10.0266V9.18105C7.5 8.36304 8.12498 7.73805 8.67698 7.18655C9.08147 6.78155 9.49998 6.36355 9.49998 6.03005C9.49998 5.19655 8.82698 4.51855 8 4.51855C7.15902 4.51855 6.5 5.16755 6.5 5.99605C6.5 6.27205 6.27602 6.49604 6 6.49604C5.72398 6.49604 5.5 6.27204 5.5 5.99604C5.5 4.63005 6.62147 3.51855 8 3.51855C9.37853 3.51855 10.5 4.64505 10.5 6.03005C10.5 6.77855 9.9325 7.34554 9.384 7.89405C8.949 8.32805 8.50002 8.77705 8.50002 9.18054V10.026C8.50002 10.3021 8.27602 10.5265 8 10.5265Z"
							fill="#2E54A6"
						/>
					</g>
				</svg>
			</div>
			<div class="no-bind-refresh-btn" @click="logoutClick">退出登录</div>
			<div class="no-bind-sub-tips">
				完成绑定后刷新本页面即可获取NAS信息
			</div>
		</div>
		<div class="tips-body" v-else>
			<div class="close-btn" @click="hideTips"></div>
			<div class="tips-title">节点小宝2.0操作指南</div>
			<div class="tips-item-title">
				<span class="icon"></span><span>如何绑定Nas设备？</span>
			</div>
			<div class="tips-item-desc">
				<span class="icon"></span
				><span
					>前往NAS套件中心下载节点小宝2.0套件；群晖套件：点击对应的平台下载插件。</span
				>
			</div>
			<div class="tips-downloads">
				<div
					class="tips-download"
					@click="jumpDownload($store.state.app_url.qh_x86)"
				>
					DSM6_x86
				</div>
				<div
					class="tips-download"
					@click="jumpDownload($store.state.app_url.qh_arm)"
				>
					DSM6_arm
				</div>
				<div
					class="tips-download"
					@click="jumpDownload($store.state.app_url.qh_dsm7_x86)"
				>
					DSM7_x86
				</div>
				<div
					class="tips-download"
					@click="jumpDownload($store.state.app_url.qh_dsm7_arm)"
				>
					DSM7_arm
				</div>
			</div>
			<div class="tips-item-desc">
				<span class="icon"></span
				><span
					>安装并打开节点小宝2.0套件后使用微信扫一扫登录节点小宝2.0，登录即绑定。</span
				>
			</div>
			<div class="tips-item-title">
				<span class="icon"></span><span>绑定后怎么使用节点小宝？</span>
			</div>
			<div class="tips-item-desc">
				<span class="icon"></span
				><span
					>PC端：https://yc.ionewu.com/jdxb/
					打开网页后，使用微信扫一扫即可登录，若已绑定手机，可使用手机及短信验证码登录，登录后可远程管理设备；</span
				>
			</div>
			<div class="tips-item-desc">
				<span class="icon"></span><span>手机端：即将上线。</span>
			</div>

			<div class="tips-item-title">
				<span class="icon"></span><span>如何修改缓存路径?</span>
			</div>

			<div class="tips-item-desc">
				<span class="icon"></span
				><span
					>控制面板→共享文件夹→选中“OWSpeedup”→点击编辑→常规→所在位置→选择用于缓存的磁盘。</span
				>
			</div>

			<!-- <div class="tips-item-title">
				<span class="icon"></span><span>登录时提示设备已被绑定?</span>
			</div>
			<div class="tips-item-desc">
				<span class="icon"></span><span>套件中心：卸载节点小宝</span>
			</div>
			<div class="tips-item-desc">
				<span class="icon"></span
				><span>控制面板：共享文件夹，删除OWSpeedup文件夹</span>
			</div>
			<div class="tips-item-desc">
				<span class="icon"></span><span>重启NAS</span>
			</div>
			<div class="tips-item-desc">
				<span class="icon"></span
				><span>控制面板：网络→常规→改【自定义名称】</span>
			</div>
			<div class="tips-item-desc">
				<span class="icon"></span
				><span>套件中心：重新安装2.0.0版本</span>
			</div> -->
			<div class="tips-sure-btn" @click="hideTips">确 定</div>
		</div>
	</div>
</template>

<script>
export default {
	data: function () {
		return {
			isShowTips: false,
		};
	},
	methods: {
		jumpDownload: function (url) {
			let _that = this;
			_that.$common.bridge(_that.$store.state.client).openBrowser(url);
		},
		showTips: function () {
			this.isShowTips = true;
		},
		hideTips: function () {
			this.isShowTips = false;
		},
		refreshClick: function () {
			window.location.reload();
		},
		logoutClick: function () {
			let _that = this;
			_that.$common.localStorage.removeItem("jdxb-uid");
			_that.$common.localStorage.removeItem("jdxb-openid");
			_that.$common.localStorage.removeItem("jdxb-name");
			_that.$common.localStorage.removeItem("jdxb-avatar");
			_that.$common.localStorage.removeItem("jdxb-owcode");
			_that.$common.localStorage.removeItem("jdxb-rkey");
			_that.$common.localStorage.removeItem("jdxb-phone");
			window.location.reload();
		},
	},
};
</script>

<style lang="less" scoped>
.no-bind-wrap {
	width: 100%;
	height: 100%;
	padding-top: 1px;
	background-color: rgba(82, 82, 82, 0.36);
	position: relative;
	.tips-body::-webkit-scrollbar {
		display: none;
	}
	.tips-body {
		-ms-overflow-style: none;
		scrollbar-width: none;
		text-align: center;
		margin-top: -225px;
		margin-left: -245px;
		width: 490px;
		height: 450px;
		background-color: #f5f5f5;
		border-radius: 5px;
		padding-top: 1px;
		position: absolute;
		left: 50%;
		top: 50%;
		overflow-y: scroll;

		.close-btn {
			width: 20px;
			height: 20px;
			background-image: url(../assets/home/node/close.png);
			background-size: 100% 100%;
			position: absolute;
			right: 10px;
			top: 10px;
		}

		.close-btn:hover {
			cursor: pointer;
			opacity: 0.9;
		}

		.tips-title {
			color: #1a1a1a;
			font-size: 20px;
			font-weight: bolder;
			margin-top: 35px;
		}
		.tips-downloads {
			margin-top: 10px;
			.tips-download {
				padding: 2px 5px;
				background-color: #e8ecf4;
				border: 1px solid #1f5de3;
				display: inline-block;
				color: #666666;
				font-size: 12px;
				border-radius: 4px;
				margin: 0 5px;
			}
			.tips-download:hover {
				cursor: pointer;
				opacity: 0.8;
			}
		}
		.tips-item-title {
			text-align: left;
			color: #666666;
			font-size: 14px;
			font-weight: bolder;
			margin-left: 40px;
			margin-top: 20px;
			span {
				display: inline-block;
				vertical-align: middle;
			}
			.icon {
				width: 10px;
				height: 10px;
				background: #1f5de3;
				border-radius: 102px 102px 102px 102px;
				opacity: 1;

				margin-right: 5px;
			}
		}
		.tips-item-desc {
			text-align: left;
			color: #666666;
			font-size: 12px;
			margin-left: 55px;
			margin-top: 14px;
			span {
				vertical-align: top;
				display: inline-block;
				width: 380px;
			}
			.icon {
				width: 5px;
				height: 5px;
				border: 1px solid #1f5de3;
				border-radius: 102px 102px 102px 102px;
				opacity: 1;
				margin-right: 5px;
				margin-top: 5px;
			}
		}
		.tips-sure-btn {
			margin: 35px auto 20px auto;
			background-color: #215fe4;
			border-radius: 20px;
			width: 140px;
			height: 40px;
			line-height: 40px;
			color: #ffffff;
			font-size: 16px;
		}
		.tips-sure-btn:hover {
			cursor: pointer;
			opacity: 0.9;
		}
	}
	.no-bind-body {
		text-align: center;
		margin-top: -175px;
		margin-left: -165px;
		width: 330px;
		height: 350px;
		background-color: #f5f5f5;
		border-radius: 5px;
		padding-top: 1px;
		position: absolute;
		left: 50%;
		top: 50%;
		.refresh-btn {
			position: absolute;
			right: 15px;
			top: 10px;
			font-size: 12px;
			color: #999999;
			span {
				vertical-align: middle;
			}
			svg {
				vertical-align: middle;
				width: 12px;
				margin-left: 2px;
				margin-right: 2px;
			}
		}
		.refresh-btn:hover {
			cursor: pointer;
			opacity: 0.8;
		}
		.no-bind-title {
			color: #1a1a1a;
			font-size: 20px;
			font-weight: bolder;
			margin-top: 35px;
		}
		.no-bind-tips {
			color: #666666;
			font-size: 14px;
			margin-top: 20px;
		}
		.no-bind-app-name {
			color: #666666;
			font-size: 14px;
			margin-top: 5px;
			font-weight: bolder;
		}
		.no-bind-app-icon {
			background-image: url(../assets/home/node/app_icon.svg);
			width: 77px;
			height: 77px;
			background-size: 100% 100%;
			margin: 0 auto;
			margin-top: 13px;
		}
		.no-bind-help {
			color: #2e54a6;
			font-size: 12px;
			margin-top: 14px;

			span {
				vertical-align: middle;
			}

			svg {
				vertical-align: middle;
				margin-left: 4px;
				width: 14px;
			}
		}
		.no-bind-help:hover {
			cursor: pointer;
			opacity: 0.8;
		}
		.no-bind-refresh-btn {
			width: 143px;
			height: 36px;
			line-height: 36px;
			color: #ffffff;
			background-color: #215fe4;
			border-radius: 18px;
			margin: 0 auto;
			margin-top: 16px;
		}
		.no-bind-refresh-btn:hover {
			cursor: pointer;
			opacity: 0.9;
		}
		.no-bind-sub-tips {
			font-size: 12px;
			color: #999999;
			margin-top: 14px;
		}
	}
}
</style>